import { render, staticRenderFns } from "./monitoringAids.vue?vue&type=template&id=1a5eb1bc&scoped=true"
import script from "./monitoringAids.vue?vue&type=script&lang=js"
export * from "./monitoringAids.vue?vue&type=script&lang=js"
import style0 from "./monitoringAids.vue?vue&type=style&index=0&id=1a5eb1bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5eb1bc",
  null
  
)

export default component.exports